import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

// Components
import { Text } from '../../..'
import BotHead from '../../../shared/Avatar/BotHeadColored'

// Styles
import styles from './FailureMessage.module.scss'

const propTypes = {
  className: PropTypes.string
}

const FailureMessage = ({ className, ...restProps }) => (
  <div className={className} {...restProps}>
    <BotHead size='l' type='error' quizzical />
    <Text
      className={styles.headline}
      element='h1'
      size='xxxl'
      weight='light'
      variant='neutralCool'
      variantCount='900'
      paragraph
    >
      <FormattedMessage id='TYV.failure.headline' defaultMessage='Oh no!' />
    </Text>
    <Text variant='neutralCool' variantCount='600' transform='uppercase' size='xs' weight='bold'>
      <FormattedMessage
        id='TYV.failure.explain'
        defaultMessage='Something went wrong and we didn’t update your home value. Please try again.'
      />
    </Text>
  </div>
)

FailureMessage.propTypes = propTypes

export default FailureMessage
